module.exports = __webpack_public_path__ + "50824899c8f8f8ab63d6a6b3e1509ea0.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1_variable/public/picture/Chinese.jpg
// module id = 465
// module chunks = 0